import { Download, FileText } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { toSafeHtml } from "../lib/content";
import type { LegalContent } from "../types";
import { PublicPageSkeleton } from "../components/LoadingSkeleton";

export function DownloadsPage() {
  const { content, loading } = useContent();
  const { downloads } = content;
  if (loading) return <PublicPageSkeleton variant="cards" />;
  return <><section className="page-hero page-hero--simple"><div className="page-width"><span className="eyebrow eyebrow--light"><span /> {downloads.eyebrow}</span><h1>{downloads.title}</h1><p>{downloads.intro}</p></div></section><section className={`section page-width documents-grid ${downloads.documents.length === 0 ? "documents-grid--empty" : ""}`}>{downloads.documents.map((document) => <a href={document.href} key={document.id} download><FileText /><div><h2>{document.title}</h2>{document.text && <p>{document.text}</p>}</div><Download /></a>)}{downloads.documents.length === 0 && <div className="documents-empty"><FileText /><h2>Zurzeit keine Downloads</h2><p>Neue Dokumente werden hier veröffentlicht.</p></div>}</section></>;
}

export function ImpressumPage() {
  const { content, loading } = useContent();
  const { imprint } = content;
  if (loading) return <PublicPageSkeleton variant="article" />;
  return <LegalPage content={imprint} />;
}

export function DatenschutzPage() {
  const { content, loading } = useContent();
  const { privacy } = content;
  if (loading) return <PublicPageSkeleton variant="article" />;
  return <LegalPage content={privacy} />;
}

function LegalPage({ content }: { content: LegalContent }) {
  return <><section className="page-hero page-hero--simple"><div className="page-width"><span className="eyebrow eyebrow--light"><span /> Rechtliches</span><h1>{content.title}</h1>{content.intro && <p>{content.intro}</p>}</div></section><section className="section legal-content" dangerouslySetInnerHTML={{ __html: toSafeHtml(content.body) }} /></>;
}
